<template>
  <div>
    <div class="ml-md-3 searchCond-wrapper">
      <div>
        <label
          class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0 mr-md-3"
        >
          所在地
        </label>
        <div class="d-md-inline text-left">
          <select
            class="d-inline form-control col-4 col-md-3 ml-md-2"
            v-model="searchCond.TODO_CD"
            @change="changePref"
          >
            <option
              v-for="pref in prefList"
              :value="pref.value"
              :key="pref.value"
            >
              {{ pref.text }}
            </option>
          </select>
          <select
            class="d-inline form-control col-7 col-md-4 ml-2"
            v-model="searchCond.SHIKU_CD"
            :disabled="!cityList.length"
            @change="changeCity"
          >
            <option :value="null">未選択</option>
            <option
              v-for="city in cityList"
              :value="city.value"
              :key="city.value"
            >
              {{ city.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-md-2">
        <label class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0">
          絞り込み
        </label>
        <input
          type="text"
          class="d-inline form-control col-12 col-md-8 ml-md-2"
          v-model="searchCond.NAME"
          @change="search"
        />
      </div>
    </div>
    <div class="ml-2 ml-md-4">
      <p v-if="!isLoading" class="mt-2 ml-4 kome red">
        オークション会場は「直接指定」からご指定ください
      </p>
    </div>

    <div v-if="!isDialog" class="text-right mx-2">
      <b-button
        class="d-inline btn sp-fs-14"
        @click="isDeleteConfirm = true"
        :disabled="!selectedItem"
      >
        削除
      </b-button>
      <b-button
        class="d-inline btn btn-success sp-fs-14"
        @click="edit"
        :disabled="!selectedItem"
      >
        編集
      </b-button>
      <b-button class="d-inline btn btn-success sp-fs-14" @click="add">
        追加
      </b-button>
    </div>

    <div class="mt-4 mt-md-3 ml-md-3 mx-auto">
      <label class="d-inline col-3 col-md-2 col-lg-2 px-0">選択：</label>
      <span v-if="isMobile" class="bold blue col-8 col-md-9 px-0">
        {{
          !selectedItem ? '選択なし' : _omitText(selectedItem.HIKINO_MEI, 22)
        }}
      </span>
      <span v-else class="bold blue col-8 col-md-9 px-0">
        {{ !selectedItem ? '選択なし' : omitText(selectedItem.HIKINO_MEI, 28) }}
      </span>
    </div>
    <div v-if="isError" class="err-message ml-md-3 mx-auto mb-md-2 border-red">
      <p>選択必須です。</p>
    </div>

    <section id="order-master-hikino">
      <div v-if="isLoading" class="spinner my-5">
        <md-progress-spinner md-mode="indeterminate" />
      </div>
      <div v-else>
        <md-table
          v-if="recordList.length"
          v-model="recordList"
          md-sort="HIKINO_MEI"
          md-sort-order="asc"
          md-card
          md-fixed-header
          :class="[
            'bg-gray mx-0 mx-md-3 p-1 black-svg checkbox',
            { 'h-250': isDialog },
          ]"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click="selected(item)"
            :class="{ selected: selectedItem && item.ID === selectedItemId }"
          >
            <md-table-cell v-if="!isMobile" md-label="">
              <input type="radio" :value="item.ID" v-model="selectedItemId" />
            </md-table-cell>
            <md-table-cell md-label="場所名" md-sort-by="HIKINO_MEI">
              <span v-if="!isMobile">{{ omitText(item.HIKINO_MEI, 20) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">場所名</p>
                <p class="col-9 p-0">{{ _omitText(item.HIKINO_MEI, 18) }}</p>
              </div>
            </md-table-cell>
            <md-table-cell md-label="住所" md-sort-by="ADDRESS">
              <span v-if="!isMobile">{{ omitText(item.ADDRESS, 20) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">住所</p>
                <p class="col-9 p-0">{{ _omitText(item.ADDRESS, 18) }}</p>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center my-5 bold">該当データがありません。</div>
      </div>
    </section>

    <!--お気に入り編集モーダル -->
    <direct-edit-dialog
      :_edited-item="editedItem"
      :is-meihen="isMeihen"
      :is-show="isEditConfirm"
      @saved="search"
      @showed="isEditConfirm = false"
    />

    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteItem"
      @md-cancel="isDeleteConfirm = false"
    />

    <md-snackbar
      :class="snackbarClass"
      md-position="center"
      :md-active.sync="isSnackbar"
      md-persistent
    >
      <span>{{ snackbarText }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin' // テーブルレコードの高さ(px)
import Store from '@/store/index.js'
import _ from 'lodash'
import DirectEditDialog from '@/components/order/DirectEditDialog'

const DATA_KBN = 'FAVORITE'
export default {
  name: 'Favorite',

  components: {
    DirectEditDialog,
  },

  props: {
    /** オークション取得フラグ */
    isGetAaFlg: {
      type: Boolean,
      default: false,
    },

    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },

    /** Dialog内に表示するか */
    isDialog: {
      type: Boolean,
      default: false,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },

    /** 画面表示フラグ */
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [Mixin],
  data: () => ({
    /** 編集データ */
    editedItem: null,

    /** バリデーションを実行したことがあるかフラグ */
    isValided: false,

    /** ローディングフラグ */
    isLoading: false,

    /** 市区町村リスト */
    cityList: [],

    /** 検索条件 */
    searchCond: {
      TODO_CD: null,
      SHIKU_CD: '',
      NAME: null,
    },

    /** 登録済みテーブル一覧 */
    recordList: [],

    /** 選択データ*/
    selectedItem: null,

    /** 選択データID */
    selectedItemId: null,

    /** 編集モーダル表示フラグ */
    isEditConfirm: false,

    /** 削除モーダル表示フラグ */
    isDeleteConfirm: false,

    /** スナックバー表示フラグ */
    isSnackbar: false,

    /**スナックバークラス */
    snackbarClass: 'bg-success',

    /** スナックバーテキスト */
    snackbarText: null,

    /** オークション表示フラグ */
    isAAFlg: 0,

    /** 画面を1度でも表示したか */
    isActivated: false,
  }),

  methods: {
    /** 選択データを登録する */
    add() {
      this.editedItem = null
      this.isEditConfirm = true
    },

    /** 選択データを編集する */
    edit() {
      this.editedItem = this.deform(this.selectedItem)
      this.isEditConfirm = true
    },

    /** 削除処理 */
    deleteItem() {
      Store.dispatch('order/deleteOkiniiri', this.selectedItemId)
        .then((res) => this.search())
        .catch((err) => {
          this._alert('エラーが発生しました code: 505', false)
        })
      this.isDeleteConfirm = false
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.searchCond.TODO_CD) return
      Store.dispatch('address/getCityList', this.searchCond.TODO_CD).then(
        () => {
          const cityList = _.cloneDeep(Store.state.address.cityList)
          cityList.unshift({
            value: '',
            text: '未選択',
          })
          this.cityList = cityList
        }
      )
    },

    /**
     * お気に入り引取先選択
     * @param  {Object} item 選択した登録済み
     */
    selected(item) {
      this.selectedItem = item
      this.selectedItemId = item.ID
      const data = this.deform(item)
      this.$emit('setData', data, DATA_KBN)
      this.isAAFlg = Number(item.HIKINO_AA_CD) ? 1 : 0
    },

    /** データを変換する */
    deform(item) {
      return {
        FAVORITE_ID: item.ID,
        AA_KAISAI_BI: null,
        AA_CD: item.HIKINO_AA_SHIKI_CD,
        AA_ID: item.HIKINO_AA_CD,
        TOROKUBAYO_KO_ID: null,
        YUBIN1: item.HIKINO_YUBIN1,
        YUBIN2: item.HIKINO_YUBIN2,
        TODO_CD: item.HIKINO_TODO_CD,
        TODO_MEI: item.HIKINO_TODO_MEI,
        SHIKU_CD: item.HIKINO_SHIKU_CD,
        SHIKU_MEI: item.HIKINO_SHIKU_MEI,
        BANCHI: item.HIKINO_BANCHI,
        MEI: item.HIKINO_MEI,
        TEL: item.HIKINO_TEL,
        YUSO_KBN: item.HIKINO_YUSO_KBN,
        HCB_ZOKUSEI_CD: item.HIKINO_HCB_ZOKUSEI_CD,
        LANDMARK_KBN: item.HIKINO_LANDMARK_KBN,
        TANTO_MEI: item.HIKINO_TANTO_MEI,
        TANTO_TEL: item.HIKINO_TANTO_TEL,
        TEIKYU_BI: item.HIKINO_TEIKYU_BI,
        EIGYO_KAISI_JIKAN: item.HIKINO_EIGYO_KAISI_JIKAN,
        EIGYO_SYURYO_JIKAN: item.HIKINO_EIGYO_SYURYO_JIKAN,
        HANNYUSYUTU_JIKAN: null,
      }
    },

    /** 入力データを初期化する */
    reset() {
      this.selectedItem = null
      this.selectedItemId = null
      this.isAAFlg = 0
      this.$emit('reset', DATA_KBN)
    },

    /** 検索する */
    search() {
      this.isLoading = true
      this.reset()
      return Store.dispatch('order/getOkiniiri', this.searchCond).then(
        (list) => {
          this.recordList = list
          this.isLoading = false
        }
      )
    },

    /** 都道府県変更 */
    changePref() {
      this.cityList = []
      this.searchCond.SHIKU_CD = ''
      this.search()
      this.getCityList()
    },

    /** 市区町村変更 */
    changeCity() {
      this.search()
    },

    /** 入力状況を再現する */
    async revival() {
      const cond = this._searchCond
      this.searchCond.TODO_CD = cond.TODO_CD
      this.searchCond.SHIKU_CD = cond.SHIKU_CD
      this.getCityList()
      await this.search()
      const item = this.recordList.filter((v) => v.ID === cond.ID)[0]
      if (item) this.selected(item)
      this.callSetIsAAflg()
    },

    /** オークションフラグの設定を親に伝える */
    callSetIsAAflg() {
      this.$emit('setIsAAFlg', this.isAAFlg, DATA_KBN)
    },
  },

  computed: {
    /** 入力エラーがあるか判定 */
    isError() {
      return this.isValided && !this.selectedItem
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading(val) {
      this.$emit('loaded', val, DATA_KBN)
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond) this.revival()
        else await this.search()
        this.$emit('searched', DATA_KBN)
      }
    },

    /** バリデーション実行フラグ */
    isValid(val) {
      if (val) {
        this.isValided = true
        this.$emit('setInvalid', this.isError, DATA_KBN)
      }
    },

    /** オークションフラグ監視 */
    isAAFlg(val) {
      this.callSetIsAAflg()
    },

    /** オークション取得フラグ監視 */
    isGetAaFlg(val) {
      if (val) this.callSetIsAAflg()
    },

    /** 画面表示フラグ監視 */
    isActive(val) {
      if (val && !this.isActivated) {
        this.search()
        this.isActivated = true
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.selected
  background: $baseBlueColor
  color: #fff
.bottom-1
  margin-bottom: 1rem
.yusosaki-mei
  height: 56px
</style>



// WEBPACK FOOTER //
// src/components/order/Favorite.vue